import type { GameshowNode } from '../../schemas/gameshow.js';

/** Whether a node carries at least one non-blank narrator line. */
export const hasNonEmptyDialogue = (lines: GameshowNode['narratorDialogue']): boolean =>
  Array.isArray(lines) && lines.some(l => typeof l.dialogue === 'string' && l.dialogue.trim().length > 0);
